<template>
    <section>
        <div v-if="!single" class="is-relative">
            <h3 class="stepper__content__header">{{ $t('MEDICAL_DATA') }}</h3>
        </div>

        <steps v-if="!single" :activeStep="3" :steps="5" class="text-xs-center mb-4"></steps>

        <div class="content__wrapper">
            <div class="header__left">
                <h4 class="stepper__content__title text-xs-left">{{ $t('DO_YOU_HAVE_THYROID_DISEASE') }}</h4>
                <p class="stepper__content__title-description">
                    {{ $t('DO_YOU_HAVE_THYROID_DISEASE_2') }}
                </p>
            </div>
            <div class="description box-shadow box-shadow--arrow-left">
                {{ $t('INFLUENCE_ON_BODY_TEMPERATURE') }}
            </div>

            <div class="content__wrapper flex-center">
                <div class="flex-center flex-row">
                    <label class="fake-label">
                        <input class="custom-input" type="radio" value="YES" name="radio" v-model="s4q3Val" />
                        <span class="input-container">{{ $t('YES') }}</span>
                        <span class="checkmark"></span>
                    </label>
                    <label class="fake-label">
                        <input class="custom-input" type="radio" value="NO" name="radio" v-model="s4q3Val" />
                        <span class="input-container">{{ $t('NO') }}</span>
                        <span class="checkmark"></span>
                    </label>
                </div>
            </div>

            <div class="text-center">
                <div v-if="single">
                    <button @click.stop="cancel()" class="w160 mr-3 app-btn app-btn--small app-btn-default mt-3">
                        {{ $t('CANCEL') }}
                    </button>
                    <button
                        v-if="s4q3Val"
                        @click.stop="save()"
                        class="w160 mr-3 app-btn app-btn--small app-btn-primary mt-3"
                    >
                        {{ $t('SAVE') }}
                    </button>

                    <button v-if="!s4q3Val" class="w160 mr-3 app-btn app-btn--small mt-3" style="opacity: 0.5">
                        {{ $t('SAVE') }}
                    </button>
                </div>

                <div v-else>
                    <button @click.stop="goTo(2)" class="w160 mr-3 app-btn app-btn--small app-btn-default mt-3">
                        {{ $t('PREVIOUS') }}
                    </button>
                    <button
                        v-if="s4q3Val"
                        @click.stop="goTo(4)"
                        class="w160 mr-3 app-btn app-btn--small app-btn-primary mt-3"
                    >
                        {{ $t('NEXT') }}
                    </button>
                    <button v-if="!s4q3Val" class="w160 mr-3 app-btn app-btn--small mt-3" style="opacity: 0.5">
                        {{ $t('NEXT') }}
                    </button>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import Steps from './helpers/steps.vue';

export default {
    mounted() {
        this.s4q3Val = this.$store.getters.survey.section4.q3;
    },
    name: 'survey-step4-q3',
    props: {
        s4q3: String,
        single: Boolean,
    },
    data() {
        return {
            s4q3Val: this.s4q3,
            checkboxes: {
                wadySerca: null,
                tetniaki: null,
                chorobyTarczycy: null,
                autoimmunologiczne: null,
                chorobyKrazenia: null,
                inneNowotwory: null,
                nowotworPluc: null,
                POCHP: null,
                astma: null,
                gruzlica: null,
                sarkoidoza: null,
                wloknistoTorbielowata: null,
            },
        };
    },
    computed: {
        activeSection() {
            return this.$store.getters.survey.section4.active_section;
        },
    },
    methods: {
        goTo(id) {
            this.$store.commit('STATE_SURVEY', {
                section4: {
                    ...this.$store.getters.survey.section4,
                    active_section: id,
                    q3: this.s4q3Val,
                },
            });
        },
        completeSection(id) {
            this.$store.commit('STATE_SURVEY', {
                activeStepper: id + 1,
            });
            this.$store.commit('STATE_SURVEY', {
                section4: {
                    ...this.$store.getters.survey.section4,
                    q3: this.s4q3Val,
                },
            });
        },
        cancel() {
            this.$emit('cancel');
        },
        save() {
            this.$store.commit('STATE_SURVEY', {
                section4: {
                    ...this.$store.getters.survey.section4,
                    q3: this.s4q3Val,
                },
            });
            this.$emit('save');
        },
    },
    components: {
        Steps,
    },
};
</script>

<style lang="scss">
.header__left {
    width: 50%;
    float: left;
    padding-right: 25px;

    @media (max-width: 768px) {
        width: 100%;
        padding-right: 0;
    }
}
</style>



// WEBPACK FOOTER //
// survey-step4-q3.vue?e300f204